<template>
  <a-select
    show-search
    :value="value"
    placeholder="Select Product"
    style="width: 100%"
    :filterOption="false"
    :default-active-first-option="false"
    :show-arrow="true"
    :not-found-content="null"
    @search="fetchProducts"
    @change="handleChange">
    <a-spin v-if="fetching" slot="notFoundContent" size="small"/>
    <a-select-option v-for="d in data" :key="d.id" :value="d.name">
      {{ d.name }}
    </a-select-option>
  </a-select>
</template>

<script>
export default {
  name: "single-product-autocomplete",
  props: {
    currentValue: {
      type: String
    }
  },
  data() {
    this.fetchProducts = _.debounce(this.fetchProducts, 800)

    return {
      data: [],
      value: this.currentValue,
      fetching: false
    }
  },
  methods: {
    fetchProducts(value) {
      this.data = []
      this.fetching = true
      this.$http.get(this.routeUri('hyperion.product'), {
        params: {q: value}
      })
        .then((response) => this.data = response.data.data)
        .finally(() => this.fetching = false)
    },
    handleChange(value) {
      this.$emit('change', _.filter(this.data, (o) => o.name === value)[0])

      Object.assign(this, {
        value,
        data: [],
        fetching: false
      })
    }
  }
}
</script>

<style scoped>

</style>
